<HomeNavBar ref="homeNavBarRef" @active_profile="set_active_home_profile" />

<div class="px-2 h-100 marketplace-shell-wrap">
  <div class="container-fluid mt-2 marketplace-page-shell h-100">
    <div class="mb-3">
      <button
        @click="$router.push({ name: 'Marketplace' })"
        class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
      >
        <i class="bi bi-chevron-left fs-5"></i>
      </button>
    </div>

    <div
      v-if="loading"
      class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
      role="status"
      aria-live="polite"
    >
      <div class="marketplace-loader-card">
        <div class="marketplace-loader-orbit">
          <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
          <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
          <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
            <i class="bi bi-shop fs-2 text-primary"></i>
          </span>
          <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
          <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
        </div>
        <p class="marketplace-loader-title mb-1">Loading shop</p>
        <p class="marketplace-loader-copy mb-0">We are bringing your listings and activity into view.</p>
      </div>
    </div>

    <div v-else>
      <div class="row align-items-center marketplace-header mb-3 g-3">
        <div class="col-12 col-lg-3">
          <div class="d-flex flex-column align-items-start gap-2">
            <h4 class="text-dark mb-1 fw-bold marketplace-toolbar-title">{{ shop_title }}</h4>
            <p class="text-muted small mb-0">Manage your marketplace listings and customer activity.</p>
            <button
              class="btn btn-sm btn-primary text-xxs rounded d-none d-lg-inline-block"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#addItemModal"
              @click="set_modal_type(active_tab === 'services' ? 'service' : 'product')"
              v-if="['products', 'services'].includes(active_tab)"
            >
              Add {{ active_tab === 'services' ? 'Service' : 'Product' }}
            </button>
            <button
              v-if="active_tab === 'products' && catalogue_products.length"
              class="btn btn-sm btn-primary text-xxs rounded d-none d-lg-inline-block"
              type="button"
              @click="open_catalogue_promo_code_manager"
            >
              Catalogue Promo
            </button>
          </div>
        </div>
<div class="col-12 col-lg-6 text-center">
          <div class="marketplace-toolbar-center">
            <div class="d-inline-block mw-100">
            <div class="marketplace-tabs-shell">
              <div class="d-flex flex-nowrap overflow-auto justify-content-lg-center">
                <button class="marketplace-tab-btn fw-semibold text-nowrap" :class="{ 'is-active': active_tab === 'products' }" type="button" @click="active_tab = 'products'">
                  Products
                </button>
                <button class="marketplace-tab-btn fw-semibold text-nowrap" :class="{ 'is-active': active_tab === 'services' }" type="button" @click="active_tab = 'services'">
                  Services
                </button>
                <button class="marketplace-tab-btn fw-semibold text-nowrap" type="button" @click="view_all_orders">
                  Orders
                </button>
                <button class="marketplace-tab-btn fw-semibold text-nowrap " :class="{ 'is-active': active_tab === 'requests' }" type="button" @click="active_tab = 'requests'">
                  Requests
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-start">
              <button
                class="btn btn-sm btn-primary text-xxs rounded d-lg-none mt-2"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#addItemModal"
                @click="set_modal_type(active_tab === 'services' ? 'service' : 'product')"
                v-if="['products', 'services'].includes(active_tab)"
              >
                Add {{ active_tab === 'services' ? 'Service' : 'Product' }}
              </button>
              <button
                v-if="active_tab === 'products' && catalogue_products.length"
                class="btn btn-sm btn-primary text-xxs rounded d-lg-none mt-2 ms-2"
                type="button"
                @click="open_catalogue_promo_code_manager"
              >
                Catalogue Promo
              </button>
            </div>
            </div>
          </div>
        </div>

      </div>

      <div class="scrollable-container marketplace-shop-scroll flex-grow-1 pb-5 mb-5">
      <div v-if="active_tab === 'products' || active_tab === 'services'" class="row g-1 marketplace-products-grid">
        <div v-if="catalogue_items.length === 0" class="col-12">
          <div class="text-center py-5">
            <i :class="active_tab === 'services' ? 'bi bi-tools' : 'bi bi-box-seam'" class="display-4 text-muted"></i>
            <h5 class="fw-bold mt-3">No {{ active_tab }} yet</h5>
            <p class="text-muted mb-0">Your {{ active_tab }} will appear here once they are created.</p>
          </div>
        </div>

        <div
          v-for="product in catalogue_items"
          :key="product.id"
          class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 mb-1"
        >
          <div class="marketplace-product-card h-100 d-flex flex-column" @click="view_product_details(product)">
            <div class="position-relative marketplace-card-media">
              <div class="ratio ratio-4x3">
                <img
                  :src="product.images.length ? product.images[0].image_url : require('@/assets/images/image_placeholder.jpg')"
                  :alt="product.name"
                  class="marketplace-card-image"
                />
              </div>

              <div class="position-absolute top-0 end-0 m-2">
                <div class="d-flex gap-2">
                  <span
                    class="badge"
                    :class="product.is_published ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                  >
                    {{ product.is_published ? 'Published' : 'Draft' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
              <div class="flex-grow-1">
                <p class="marketplace-card-name mb-1">{{ product.name }}</p>
                <p v-if="product?.service_details?.location" class="text-xs text-muted mb-0 mt-1">
                  <i class="bi bi-geo-alt-fill text-primary"></i>
                  <span><strong> Location:</strong> {{ product?.service_details?.location }}</span>
                </p>
              </div>

              <div class="d-flex justify-content-between align-items-end gap-2 mt-3 marketplace-card-footer">
                <div class="marketplace-card-price-wrap">
                  <span class="marketplace-card-price">R{{ format_price(display_price(product)) }}</span>
                </div>
              </div>

              <div class="mt-3">
                <div class="d-flex flex-wrap gap-1">
                  <button class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill" @click.stop="toggle_publish(product)">
                    {{ product.is_published ? 'Unpublish' : 'Publish' }}
                  </button>
                  <button class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill" @click.stop="open_manage_modal(product)">
                    Manage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="active_tab === 'orders'" class="row g-3 pb-extra-desktop">
        <div v-if="pending_orders.length === 0" class="col-12">
          <div class="text-center py-5">
            <i class="bi bi-inbox text-muted display-6"></i>
            <p class="text-muted text-xs mt-2 mb-0">No orders yet</p>
          </div>
        </div>

        <div v-for="order in pending_orders" :key="order.id" class="col-12 col-md-6 col-lg-4 col-xxl-3 py-5">
          <div class="card border-0 shadow-sm rounded bg-light h-100">
            <div class="card-body p-3">
              <div class="d-flex align-items-center gap-2 mb-2">
                <div class="avatar-sm rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
                  <i class="bi bi-person text-primary text-xs"></i>
                </div>
                <div class="flex-fill overflow-hidden">
                  <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ order.buyer_name }}</p>
                  <small class="text-muted text-xxs">{{ order.items.length }} items · R{{ format_price(order.total_amount) }}</small>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <small class="text-muted text-xxs">{{ format_date(order.created_at) }}</small>
                <button class="btn btn-sm btn-primary text-xxs rounded" @click="view_all_orders">
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row g-3 pb-extra-desktop">
        <div v-if="pending_requests.length === 0" class="col-12">
          <div class="text-center py-5">
            <i class="bi bi-telephone text-muted display-6"></i>
            <p class="text-muted text-xs mt-2 mb-0">No requests yet</p>
          </div>
        </div>

        <div v-for="request in pending_requests" :key="request.id" class="col-12 col-md-6 col-lg-4 col-xxl-3">
          <div class="card border-0 shadow-sm rounded p-3 h-100">
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="flex-fill overflow-hidden">
                <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ request?.requester?.user?.first_name + ' ' + request?.requester?.user?.last_name }}</p>
                <small class="text-muted text-xxs text-truncate d-block">{{ request?.product?.name }}</small>
              </div>
              <span
                class="badge rounded-pill text-xxs"
                :class="{'bg-warning text-dark': request.status.name.toLowerCase() === 'pending','bg-success': request.status.name.toLowerCase() === 'approved',
                'bg-info': request.status.name.toLowerCase() === 'completed','bg-primary': request.status.name.toLowerCase() === 'cancelled',
                'bg-secondary': request.status.name.toLowerCase() === 'confirmed','bg-danger': request.status.name.toLowerCase() === 'declined',
                'bg-dark text-white': request.status.name.toLowerCase() === 'disputed'}"
              >
                {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
              </span>
            </div>
            <div class="bg-light rounded p-2 mb-2">
              <small class="text-muted text-xxs fst-italic">{{ request?.message }}</small>
            </div>
            <div class="bg-light rounded p-2 mb-2">
              <small class="d-block text-xxs fw-semibold mb-1">Contacts</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.email }}</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.contact_number }}</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.location ? 'Location: ' + request?.location : 'Location: Not provided'}}</small>
              <small class="text-muted text-xxs d-block mb-2">{{ 'Preferred Date: ' + format_date(request?.request_date) }}</small>
            </div>
            <div v-if="request?.status?.name.toLowerCase() === 'pending'" class="d-flex gap-1">
              <button
                class="btn btn-sm btn-primary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="update_request(request, 'approve', request.decline_reason)"
              >
                <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                Accept
              </button>
              <button
                class="btn btn-sm btn-secondary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="request.show_decline = !request.show_decline"
              >
                Decline
              </button>
            </div>
            <div v-if="request.show_decline" class="mt-2">
              <textarea v-model="request.decline_reason" rows="2" class="form-control form-control-sm rounded mb-2 text-xxs" placeholder="Reason for declining..."></textarea>
              <div class="d-flex gap-1">
                <button
                  class="btn btn-sm btn-danger rounded flex-fill text-xxs"
                  :disabled="request.is_loading"
                  @click="update_request(request, 'decline', request.decline_reason); request.show_decline = false"
                >
                  <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                  Submit
                </button>
                <button class="btn btn-sm btn-light rounded flex-fill text-xxs" @click="request.show_decline = false; request.decline_reason = ''">
                  Cancel
                </button>
              </div>
            </div>
            <div v-if="['approved', 'disputed'].includes(request?.status?.name.toLowerCase())" class="d-flex gap-1">
              <button
                class="btn btn-sm btn-primary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="update_request(request, 'complete', request.decline_reason)"
              >
                <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                Complete
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<CatalogueView :vm="view_model" />

<ProductPromoCode
  ref="productPromoCodeRef"
  @promo-updated="update_parent_product_promos"
  @promo-deleted="handle_parent_product_promo_deletion"
/>

